import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteAccountLogo, uploadAccountLogo } from "@/adapters/api";

export function useUploadAccountLogo(accountId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (file: File) => {
			if (!accountId) throw new Error("missing account");
			return uploadAccountLogo(accountId, file);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["me"] });
		},
	});
}

export function useDeleteAccountLogo(accountId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => {
			if (!accountId) throw new Error("missing account");
			return deleteAccountLogo(accountId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["me"] });
		},
	});
}
